import { apiFetch } from "./api";

export type FinanceTone = "ready" | "warning" | "danger" | "info";

export type FinanceWorkbenchSummary = {
  month: string;
  generatedAt: string;
  connection: {
    status: "connected";
    label: string;
    note: string;
    sources: Array<{ label: string; status: string; tone: FinanceTone }>;
  };
  metrics: Array<{ label: string; value: string; tone?: "good" | "warning" | "danger" }>;
  todos: Array<{
    tone: FinanceTone;
    label: string;
    title: string;
    detail: string;
    action: string;
  }>;
  monthlySteps: Array<{
    index: string;
    title: string;
    detail: string;
    status: string;
    tone: FinanceTone;
  }>;
  ledgerRows: Array<{
    date: string;
    summary: string;
    suggestion: string;
    status: string;
    tone: FinanceTone;
    amount: string;
  }>;
  quickEntries: Array<{
    title: string;
    detail: string;
    action: string;
    highlight?: boolean;
  }>;
  drawer: {
    title: string;
    amount: string;
    matched: string;
    gap: string;
  };
  safety: {
    impactPeriod: string;
    impactAmount: string;
    notificationTargets: string;
    currentStatus: string;
  };
};

export function loadFinanceWorkbenchSummary(month: string) {
  const params = new URLSearchParams({ month });
  return apiFetch<FinanceWorkbenchSummary>(`/finance/workbench-summary?${params.toString()}`);
}
